import React from "react";
import { OpenCloseHookProps } from "../../../utils/hooks/OpenCloseHook";

interface EdgeProps {
  text: string;
  pdfOpen: OpenCloseHookProps;
  link?: string;
}

const Edge: React.FC<EdgeProps> = ({ text, pdfOpen, link = "" }) => {
  return (
    <div>
      <div className="edge-desc">
        <h6>{text}</h6>
        {link && <span  style={{ color: 'blue'}} onClick={() => pdfOpen.open(link)}>read more...</span>}
      </div>
    </div>
  );
};

export default Edge;
